import clsx from "clsx";
import React from "react";
import {StyledButton} from "./DefaultButton.styles";

interface DefaultButtonProps {
    children: React.ReactNode;
    className?: string;
    variant?: "text" | "outlined" | "contained";
    size?: "small" | "medium" | "large";
    color?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    onClick?: (e: any) => void;
}

const DefaultButton: React.FC<DefaultButtonProps> = (
    {
        children,
        className,
        variant,
        size,
        color,
        ...props }) => {
    return (
        <StyledButton
            {...props}
            variant={variant}
            size={size}
            color={color}
            className={clsx(className)}
        >
            {children}
        </StyledButton>);
}

export default DefaultButton;